if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                    viewer: this.querySelector('[id^="GalleryViewer"]'),
                    thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
                    dots: this.querySelector('[id^="DotsThumbnails"]'),
                };
                this.mql = window.matchMedia('(min-width: 750px)');
                if (!this.elements.thumbnails && !this.elements.dots) return;

                this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
                [this.elements.thumbnails, this.elements.dots].filter(Boolean).forEach((container) => {
                    container.addEventListener('click', (event) => {
                        const mediaToSwitch = event.target.closest('[data-target]');
                        if (!mediaToSwitch) return;
                        this.setActiveMedia(mediaToSwitch.dataset.target, false);
                    });
                });
                if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
            }

            onSlideChanged(event) {
                const thumbnail = this.querySelector(
                    `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
                );
                this.setActiveThumbnail(thumbnail);
            }

            setActiveMedia(mediaId, prepend) {
                const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
                if (!activeMedia) return;
                this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                    element.classList.remove('is-active');
                });
                activeMedia.classList.add('is-active');

                if (prepend) {
                    const shouldReorder = !this.elements.dots || this.elements.dots.querySelector(`[data-target="${mediaId}"]`);
                    if (shouldReorder && activeMedia.parentElement.firstChild !== activeMedia) {
                        activeMedia.parentElement.prepend(activeMedia);
                    }

                    if (this.elements.thumbnails) {
                        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                        activeThumbnail?.parentElement?.firstChild !== activeThumbnail &&
                            activeThumbnail?.parentElement?.prepend(activeThumbnail);
                    }

                    if (this.elements.dots) {
                        const activeDot = this.elements.dots.querySelector(`[data-target="${mediaId}"]`);
                        activeDot?.parentElement?.firstChild !== activeDot &&
                            activeDot?.parentElement?.prepend(activeDot);
                    }

                    if (shouldReorder && this.elements.viewer.slider) this.elements.viewer.resetPages();
                }

                this.preventStickyHeader();
                window.setTimeout(() => {
                    if (!this.mql.matches || this.elements.thumbnails || this.elements.dots) {
                        activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
                    }
                    const activeMediaRect = activeMedia.getBoundingClientRect();
                    // Don't scroll if the image is already in view
                    if (activeMediaRect.top > -0.5) return;
                    const top = activeMediaRect.top + window.scrollY;
                    window.scrollTo({ top: top, behavior: 'smooth' });
                });
                this.playActiveMedia(activeMedia);

                if (!this.elements.thumbnails && !this.elements.dots) return;
                const activeThumbnail = this.querySelector(`[data-target="${mediaId}"]`);
                this.setActiveThumbnail(activeThumbnail);
                if (activeThumbnail)
                    this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
            }

            setActiveThumbnail(thumbnail) {
                if (!thumbnail) return;
                const container = thumbnail.closest('[id^="GalleryThumbnails"], [id^="DotsThumbnails"]');
                if (!container) return;

                container
                    .querySelectorAll('button')
                    .forEach((element) => element.removeAttribute('aria-current'));
                thumbnail.querySelector('button')?.setAttribute('aria-current', true);

                if (
                    container.id.startsWith('GalleryThumbnails') &&
                    container.slider &&
                    typeof container.slider.scrollTo === 'function' &&
                    container.isSlideVisible &&
                    typeof container.isSlideVisible === 'function'
                ) {
                    if (container.isSlideVisible(thumbnail, 10)) return;

                    container.slider.scrollTo({ left: thumbnail.offsetLeft });
                }
            }

            syncDotsFromSlides() {
                if (!this.elements.dots) return;
                const dotsList = this.elements.dots.querySelector('ul');
                if (!dotsList) return;

                const slides = this.elements.viewer.querySelectorAll('li[data-media-id]');
                const activeId = this.elements.viewer.querySelector('li.is-active')?.dataset.mediaId;
                const fragment = document.createDocumentFragment();

                slides.forEach((slide, index) => {
                    const item = document.createElement('li');
                    item.classList.add('dots-nav__item', 'slider__slide');
                    item.dataset.target = slide.dataset.mediaId;
                    item.dataset.mediaPosition = String(index + 1);

                    const button = document.createElement('button');
                    button.classList.add('dot');
                    button.setAttribute('aria-controls', this.elements.viewer.id);
                    button.setAttribute('aria-label', `Slide ${index + 1}`);
                    if (slide.dataset.mediaId === activeId) button.setAttribute('aria-current', 'true');

                    item.appendChild(button);
                    fragment.appendChild(item);
                });

                dotsList.innerHTML = '';
                dotsList.appendChild(fragment);
            }

            announceLiveRegion(activeItem, position) {
                const image = activeItem.querySelector('.product__modal-opener--image img');
                if (!image) return;
                image.onload = () => {
                    this.elements.liveRegion.setAttribute('aria-hidden', false);
                    this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
                        '[index]',
                        position,
                    );
                    setTimeout(() => {
                        this.elements.liveRegion.setAttribute('aria-hidden', true);
                    }, 2000);
                };
                image.src = image.src;
            }

            playActiveMedia(activeItem) {
                window.pauseAllMedia();
                const deferredMedia = activeItem.querySelector('.deferred-media');
                if (deferredMedia) deferredMedia.loadContent(false);
            }

            preventStickyHeader() {
                this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
                if (!this.stickyHeader) return;
                this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
            }

            removeListSemantic() {
                if (!this.elements.viewer.slider) return;
                this.elements.viewer.slider.setAttribute('role', 'presentation');
                this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
            }
        },
    );
}